import React from "react"
import KEYBlue from "../common/keylist-blue"

const WebappServices: React.FC = () => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="gap-5 md:gap-5 lg:gap-10 grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
            <h2 className="fw-700 fs-xl">
            Serving Multiple Segments, Our Core Web Application Development Services Include:
              </h2>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="Custom Web Development" />
            <KEYBlue text="Customer Relationship Management" />
            <KEYBlue text="Enterprise App Development" />
            <KEYBlue text="Third Party Integration" />
              
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="E-commerce, B2B &amp; B2C" />
            <KEYBlue text="Cloud Solution" />
            <KEYBlue text="Workflow Management" />
            <KEYBlue text="Any Custom Business Application" />

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WebappServices
